import { render, staticRenderFns } from "./Pagador.vue?vue&type=template&id=e813e8d0"
import script from "./Pagador.vue?vue&type=script&lang=js"
export * from "./Pagador.vue?vue&type=script&lang=js"
import style0 from "./Pagador.vue?vue&type=style&index=0&id=e813e8d0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports